export default __webpack_public_path__ + "static/media/pen.1bfa8d14.svg";